import { ref } from 'vue'
import { handleErrorMessage } from '../helpers/messageHelper'

export const useStoreRequests = () => {
  const isLoading = ref(false)

  const createRequest = <F extends (...args: any[]) => any>(
    request: F,
  ): ((...args: Parameters<F>) => Promise<Awaited<ReturnType<F>>>) => {
    return async (...args): Promise<Awaited<ReturnType<F>>> => {
      try {
        isLoading.value = true
        return await request(...args)
      } catch (err) {
        handleErrorMessage(err)
        throw err
      } finally {
        isLoading.value = false
      }
    }
  }

  return {
    isLoading,
    createRequest,
  }
}
